/**
 * @Author:      ge.yuankai
 * @DateTime:    2018-03-19
 * @Description: PGC签约渠道审核弹窗
 */
"use strict";
angular.module("channelAuditModule", ["registrationAuditServiceModule"]).
controller("channelAuditCtrl", ["$scope", "$element", "registrationAuditService", "$modalInstance", "userId", "channelId", "httpService", "modalDialog", "$validation","$q", function($scope, $element, registrationAuditService, $modalInstance, userId, channelId, httpService, modalDialog, $validation,$q) {
	initStatus();
	initData();

	function initStatus() {
		$scope.headPic = ''; //头像
		$scope.status = {
			allType: {
				0: '个人',
				1: '媒体',
				2: '国家机构',
				3: '企业',
				4: '其他组织',
			}
		};
		$scope.params = {
			userId: userId,
			channelId: channelId
		}
	};

	function initData() {
		requestData()
	}
	$scope.confirm = function() {
		validator().then(function() {
			modalDialog.backConfirmModal("审核通过", "确认通过该签约渠道的资料审核？", function() {
				var params = {
					userId: userId, // 用户ID
					channelId: channelId, // 渠道ID
					accountLogo: $scope.headPic,
					accountName: $scope.info.accountName, // 账号名称（非必填）
					accountDesc: $scope.info.accountDesc //账号介绍（非必填）

				};
				$scope.loadingPromise = httpService.http("/mcnadmin/admin/pgcuser/userChannelAuditPass.do", params, "post").then(function(data) {
					modalDialog.alertType('', '渠道通过成功', 'success');
					$modalInstance.close(data);
				});
			});
		})
	};
	$scope.cancel = function() {
		$modalInstance.dismiss();
	};
	$scope.regAuditFail = function() {
		registrationAuditService.channelAuditFail(userId, channelId).then(function(data) {
			$modalInstance.close(data);
		});
	}

	function requestData() {
		$scope.loadingPromise = httpService.http("/mcnadmin/admin/pgcuser/getUserChannel.do", $scope.params, "post").then(function(data) {
			$scope.info = data.data;
			$scope.headPic = data.data.accountLogo;
		});
	};
	/**
	 * [validator description] 表单校验
	 * @return {[type]} [description]
	 */
	function validator() {
		var deffer = $q.defer();
		$validation.validate($scope.channelAuditForm).success(function() {
			deffer.resolve();
		}).error(function(result) {
			angular.invalidPosition($scope.channelAuditForm, $element);
		});
		return deffer.promise;
	}
}]);